import { render } from "./Header.vue?vue&type=template&id=65fe3bd0&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=65fe3bd0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65fe3bd0"

export default script